import React, {useEffect} from 'react';
import * as css from './DetailItem.css';
import {useSelector} from 'react-redux';
import {getDate, getHourMinutes, getTs, tsGetDayOfWeek} from '../../../../library/dates';
import {useTranslation} from 'react-i18next';
import Timer from '../timer/Timer';
import useMobile from '../../../../hooks/useMobile';
import getSpecialTranslation from '../../../../functions/getSpecialTranslation';

function DetailItem ({title}:{title: string}) {
    const event = useSelector((s:any)=>s.event);
    const {t} = useTranslation('realtime');
    const {t: globalT} = useTranslation('global');
    const isMobile = useMobile();
    const {eventCategories} = useSelector((s:any) => s.categories);

    const category = eventCategories?.find((item)=>item.catId === event.category);
    const now = getTs();
    const prefix = event?.type === 'subscription' ? 'subscription' : 'event';
    const timeTexts = {
        willFinish: `${prefix}WillFinish`,
        willStart: `${prefix}WillStart`,
        finished: `${prefix}Finished`
    };
    
    let value;
    switch (title) {
        case 'date':
            value = event?.timeStart && `${globalT('fullDay'+tsGetDayOfWeek(event?.timeStart, event?.timeZone))}, ${getDate(event?.timeStart)}`;
            break;
        case 'timeOpen':
            value = event?.timeOpen && getHourMinutes(event?.timeOpen);
            break;
        case 'timeStart':
            value = event?.timeStart && getHourMinutes(event?.timeStart);
            break;
        case 'timer':
            value = !!event.timeStart && !isMobile  && <Timer />;
            title = (now >= event?.timeStart && now < event?.timeEnd) ? timeTexts.willFinish : (now >= event?.timeEnd ? timeTexts.finished : timeTexts.willStart);
            break;
        case 'category':
            if(!event.category)
                value = t('category0');
            else
                value = getSpecialTranslation(`category${event.category}`, t) || category?.title;
            break;
        case 'numLectures':
            value = event.numLectures;
            break;
        case 'numLecturers':
            value = event.numLecturers;
            break;
        case 'conferenceAddress':
            value = event.locationMap?.title
                ? [event.location, event.locationMap.title].filter(Boolean).join(', ')
                : event.location;
            break;
        default:
            value = t(event[title]);
            break;
    }
    if(!value)
        return <></>;
    return (
        <css.item>
            <css.title>{t(title)}</css.title>
            <css.value>{value}</css.value>
        </css.item>
    );
}

export default DetailItem;
